import ham from './modules/ham';

ham()

// const callbackForm = document.getElementById('callbackForm');

// if (callbackForm) {

//     callbackForm.addEventListener('submit', async function (e) {

//         e.preventDefault();

//         const formData = new FormData(this);

//         const response = await fetch('mailer/send.php', {
//             method: 'POST',
//             body: formData
//         });

//         const result = await response.text();

//         alert(result);

//         if (result === 'OK') {
//             this.reset();
//         }

//     });

// }

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.ajax-form').forEach(form => {

    form.addEventListener('submit', function(e) {

        e.preventDefault();

        const formData = new FormData(this);

        fetch('mailer/send.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(result => {

            if (result.trim() === 'OK') {

                alert('Спасибо! Ваша заявка успешно отправлена.');

                this.reset();

                document
                    .querySelector('#callback-modal')
                    ?.classList.remove('active');

            } else {

                alert(result);

            }

        })
        .catch(() => {

            alert('Ошибка отправки.');

        });

    });

});

});